import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCard = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="M17.857 3.214H2.143c-.789 0-1.429.64-1.429 1.429v10.714c0 .789.64 1.428 1.429 1.428h15.714c.79 0 1.429-.639 1.429-1.428V4.643c0-.79-.64-1.429-1.429-1.429M.714 8.214h18.572M13.571 13.214h2.143"
      />
    </svg>
  );
};
export default SvgCard;
